import vueMagnifier from './vue-magnifier'

vueMagnifier.install = Vue => Vue.component('vueMagnifier', vueMagnifier)
export default vueMagnifier



// WEBPACK FOOTER //
// ./src/plugin/index.js